import { Svg } from './Svg'

type Props = {
	title?: string
}

export const Logo = ({ title }: Props) => (
	<Svg viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
		{title && <title>{title}</title>}
		<path
			opacity='0.08'
			d='M30.9333 11.2656L9.66667 12.799L11 31.399L22.3333 41.2656L32.2667 29.9323L30.9333 11.2656Z'
			fill='black'
		/>
		<path d='M13.3333 10V28.6667L24 39.3333V18L34.6667 28.6667V10H13.3333Z' fill='url(#paint0_linear_6617_105123)' />
		<path d='M24 39.3333V18L34.6667 28.6667L24 39.3333Z' fill='#FFD200' />
		<defs>
			<linearGradient
				id='paint0_linear_6617_105123'
				x1='35.2184'
				y1='-7.79687'
				x2='15.9215'
				y2='38.8702'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C4BB' />
				<stop offset='1' stopColor='#009185' />
			</linearGradient>
		</defs>
	</Svg>
)
